import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {CategorySimpleSearchModel} from "../category-simple-search.model";
import {CategorySearchPageComponent} from "../category-search-page/category-search-page.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-category-exclude-sub-search-control",
    templateUrl: "./category-exclude-sub-search-control.component.html",
    providers: [
        provideSearchModel(CategorySimpleSearchModel),
        registerSearchControl(CategoryExcludeSubSearchControlComponent)
    ]
})
export class CategoryExcludeSubSearchControlComponent extends AbstractSelectSearchControlComponent<CategorySimpleSearchModel> {
    constructor(model: CategorySimpleSearchModel, injector: Injector) {
        super(model, injector, "categoryId", "name");
        this.extendedSearchComponent = CategorySearchPageComponent;
    }

    override get value(): any {
        if (!super.value) {
            return {"excludeSub": false, "categoryId": undefined};
        }
        return super.value;
    }

    onValueChange(value: any): void {
        super.value = {"excludeSub": this.value.excludeSub, "categoryId": value};
    }

    onExcludeSubChanged(checked: boolean): void {
        if (this.value.categoryId != undefined && super.value && super.value.excludeSub != checked) {
            super.value = {"excludeSub": checked, "categoryId": this.value.categoryId};
        }
    }
}
